import AnatomyV2Gender from '~/pages/anatomyV2/gender/libs/components/AnatomyV2Gender'
import { TPageProps } from '~/shared/types/commonTypes'

const GenderAnatomyV2 = (props: TPageProps) => <AnatomyV2Gender {...props} />

export default GenderAnatomyV2
